import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';

import { inject, observer } from 'mobx-react';

import Page from '@components/template/Page';
const LoginView = ({ singInWithEmailAndPassword }) => {
  const classes = useStyles(), // Declare styles
    navigate = useNavigate(), // Declare navigate
    handleSubmit = async (credentialProps, setSubmitting) => {
      // Declare Biz
      const result = await singInWithEmailAndPassword(credentialProps);
      if (result) {
        navigate('/app/dashboard', { replace: true });
      } else {
        alert('이메일 / 비밀주소를 다시 입력해주세요');
        setSubmitting(false);
      }
    };
  return (
    <Page className={classes.root} title="Login">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: 'mirae@inv.info',
              password: '12345678'
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .max(255)
                .required('아이디를 입력해주세요'),
              password: Yup.string()
                .max(255)
                .required('비밀번호를 입력해주세요')
            })}
            onSubmit={(data, { setSubmitting }) => {
              handleSubmit(data, setSubmitting);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={3} mb={1}>
                  <Typography
                    align="center"
                    color="textSecondary"
                    variant="body1"
                  >
                    미래주식 정보 관리자 로그인
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="아이디"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="비밀번호"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box my={2}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    로그인
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

export default inject(({ applicationStore }) => ({
  singInWithEmailAndPassword: applicationStore.singInWithEmailAndPassword
}))(observer(LoginView));
